<script>
import LandingPageEnableMarketplace from '../../../../../components/editor/steps/super/EnableMarketplace.vue'

export default LandingPageEnableMarketplace.extend({
  name: 'StandalonePopUpEnableMarketplace',
})
</script>